import { Observable, forkJoin, ObservableInput, of, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, finalize } from 'rxjs/operators';

@Injectable()
export class QuickeditService {
	observables: ObservableInput<any>[] = [];

	_unsavedActionsUpdate: ReplaySubject<boolean>;

	constructor() {
		this._unsavedActionsUpdate = new ReplaySubject<boolean>(1);
	}

	unsavedActionsUpdate(): Observable<boolean> {
		return this._unsavedActionsUpdate;
	}

	removeSaveActions() {
		this.observables = [];
		this._unsavedActionsUpdate.next(false);
	}

	unsavedActions(): boolean {
		return this.observables.length > 0;
	}

	addSaveAction(f: ObservableInput<any>) {
		this.observables.push(f);
		this._unsavedActionsUpdate.next(this.unsavedActions());
	}

	removeSaveAction(f: ObservableInput<any>) {
		this.observables = this.observables.filter((currentFunction) => currentFunction !== f);
		this._unsavedActionsUpdate.next(this.unsavedActions());
	}

	save(isNew = false): Observable<any[]> {
		if (!this.observables || this.observables.length === 0 || isNew) {
			return of(null);
		}
		return forkJoin(this.observables)
			.pipe(
				map((savedEntities) => {
					this.removeSaveActions();
					return savedEntities;
				}),
				finalize(() => {
					this.removeSaveActions();
					return true;
				})
			);
	}
}
